"use client";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StarRating } from "./StarRating";

type ItemRatingRowProps = {
  itemName: string;
  imageUrl?: string | null;
  value: number;
  onChange: (n: number) => void;
};

/** One row of the optional per-item rating list on the positive (4-5★) branch. */
export function ItemRatingRow({ itemName, imageUrl, value, onChange }: ItemRatingRowProps) {
  const { t } = useTranslation();
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "12px 13px" }}>
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: 9,
          background: imageUrl ? undefined : "linear-gradient(135deg, var(--primary-50), var(--primary-100, #c4ebd7))",
          backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          flexShrink: 0,
        }}
      />
      <div style={{ flex: 1, fontSize: 13.5, fontWeight: 600, color: "var(--ink-1)", minWidth: 0 }}>
        {itemName}
      </div>
      <StarRating
        value={value}
        onChange={onChange}
        size={18}
        justify="flex-start"
        groupLabel={t("v2.reviews.rate_item_aria", "Rate {{item}} 1 to 5 stars", { item: itemName }) as string}
      />
    </div>
  );
}
